module.exports = __webpack_public_path__ + "static/media/exportar-arquivo.176befb4.webp";